<template>
  <div>
    <alert
      v-if="alertVisible"
      :message="alertMessage"
      :type="alertType">
    </alert>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                {{ $t('xugarhero.changePassphrase.title') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div class="input-button-wrapper">
              <label-input
                class="input"
                label="Nightscout"
                :disabled="true"
                v-model="passphrase"
                form-size="m"
                type="text"/>
            </div>
          </grid-col>
        </grid-row>
        <grid-row column-align="center">
          <grid-col col-size="4">
            <btn-pill
              class="btn-ok"
              :btnText="$t('xugarhero.changePassphrase.generate')"
              btn-type="primary"
              btn-size="m"
              @click="updatePassphrase()">
            </btn-pill>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>

</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import LabelInput from '@/components/shared/forms/LabelInput';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Alert from '@/components/shared/alert/Alert';
import {mapActions} from 'vuex';
export default {
  name: 'ChangePassphrase',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    LabelInput,
    BtnPill,
    Alert
  },
  data () {
    return {
      passphrase: '',
      alertVisible: false,
      alertMessage: '',
      alertType: ''
    };
  },
  computed: {
    getBreadcrumb () {
      return [
        {name: this.$t('xugarhero.changePassphrase.title'), disabled: true}
      ];
    }
  },
  methods: {
    updatePassphrase () {
      const promise = this.updateNightscoutOwnPassphrase({ context: this, passphrase: this.passphrase });
      promise.then(
        (data) => {
          this.passphrase = data.bodyText;
          this.showAlert(this.$t('xugarhero.changePassphrase.success'), 'success');
        },
        () => this.showAlert('Error', 'error')
      );
      this.passphrase = '';
    },
    showAlert (message, type) {
      this.alertVisible = true;
      this.alertMessage = message;
      this.alertType = type;
      this.showAlert = true;
      setTimeout(() => {
        this.alertVisible = false;
      }, 2000);
    },
    ...mapActions([
      'updateNightscoutOwnPassphrase'
    ])
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .btn-ok {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/brand/xugarhero/layouts/ChangePassphrase.vue